import { AuthServiceInterface } from './AuthServiceInterface';

declare const firebase: any;
declare const VAPID_KEY: string;
declare const FIREBASE_CONFIG: any;

export type PushNotification = {
    notification: {
        title: string;
        body: string;
        click_action: string;
    };
    data: {
        [key: string]: any;
    };
};

export class PushNotificationService {
    static $inject = ['AuthService', '$http'];

    private onMessageSubject$: Rx.Subject<PushNotification> = new Rx.Subject();

    constructor(private authService: AuthServiceInterface, private $http: ng.IHttpService) {
        try {
            this.init();
        } catch (e) {
            console.error('Could not initialize Firebase API for Push Notifications');
        }
    }

    private init() {
        // todo: disabled it for now
        // it wasnt used and it might've caused a malwarebytes browser guard notificationLoop warning
        // /**
        //  * configuration is injected from FirebaseConfigService into a <script> tag
        //  * the injected global variables are FIREBASE_CONFIG and VAPID_KEY
        //  */
        //
        // firebase.initializeApp(FIREBASE_CONFIG);
        //
        // const messaging = firebase.messaging();
        //
        // messaging
        //     .getToken({ vapidKey: VAPID_KEY })
        //     .then((currentToken: string | null) => {
        //         if (currentToken) {
        //             this.clearPushTokenOnUserChanged(currentToken);
        //             console.log('PushNotificationService', 'firebase token', currentToken);
        //             this.updateUserToken(currentToken);
        //             return;
        //         }
        //
        //         console.log(
        //             'PushNotificationService',
        //             'No registration token available. Request permission to generate one.'
        //         );
        //     })
        //     .catch((err: any) => {
        //         console.log('PushNotificationService', 'An error occurred while retrieving token. ', err);
        //     });
        //
        // messaging.onMessage((payload: PushNotification) => {
        //     console.log('PushNotificationService', 'Message received. ', payload);
        //     this.onMessageSubject$.onNext(payload);
        // });
    }

    onMessage$() {
        return this.onMessageSubject$;
    }

    private clearPushTokenOnUserChanged(token: string) {
        this.authService.onUserChanged((user: any) => {
            // todo: clear push token
            this.$http.delete(`/api/v2.0/push-message/token?token=${token}`);
        });
    }

    private updateUserToken(token: string) {
        this.authService.onUserChanged((user: any) => {
            this.$http.post('/api/v2.0/push-message/token', { token });
        });
    }
}

angular.module('tradersyard').service('PushNotificationService', PushNotificationService);
